import { render } from "./imar.vue?vue&type=template&id=24f91cff&scoped=true"
import script from "./imar.vue?vue&type=script&lang=js"
export * from "./imar.vue?vue&type=script&lang=js"

import "./imar.vue?vue&type=style&index=0&id=24f91cff&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24f91cff"

export default script